import Config from "../../config";
import icLogoLight from "./../../assets/svg/ic_logo.png";
import DropdownLang from "./../../layouts/DropdownLang";
import ToastU from "../../components/ui/ToastU";
import Utils from './../../utils'

const Wrapper = ({children}) => {
    const organization = JSON.parse(localStorage.getItem('organization'));
    
    return (
        <div className="container-fluid vh-100">
            <div className="row h-100">
                <div className="col-md-6 d-flex flex-column justify-content-between p-5">
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-row">
                            <img src={icLogoLight} alt="logo" className="wh-30 me-1 hover-cursor"/>
                            <span className="bold fg-dark font-18 me-3">{Config.APP_NAME}</span>
                            <DropdownLang className={'border'}/>
                        </div>
                        <span className="fg-dark mt-2">{organization?.name}</span>
                    </div>
                    { children }
                    <small className="me-2">Copyright © {Utils.getYear()} Ähli hukuklar goralan</small>
                </div>
                <div className="col-md-6 d-none d-md-block p-0">
                    <div className="right-panel">
                        <div className="overlay">
                            <div>
                                <span className="medium bg-transparent-50 px-1 rounded-1">v {Config.VERSION}</span>
                            </div>
                            <small className="">Powered by <span className="fw-semibold">Alem Tilsimat</span></small>
                            <h2 className="display-5 mt-5 mb-1">{Config.APP_NAME}</h2>
                            <h2 className="display-5 mb-1">POS</h2>
                        </div>
                    </div>
                </div>
            </div>
            <ToastU/>    
        </div>
    );
}

export default Wrapper;